import ApiBaseService from './ApiBaseService';

class AuthService {

    static login(data) {
        return ApiBaseService.request('/api/web/auth/login', 'POST', data);
    }

    static refresh() {
        return ApiBaseService.request('/api/web/auth/refreshToken', 'POST', {});
    }

    static getLoginDetails(data) {
        return ApiBaseService.request('/api/web/account/me', 'GET');
    }
}

export default AuthService;